import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import { useDimensions } from "../../hooks";

interface SectionProps {
  title: string;
  children?: ReactNode;
}
const Section = ({ title, children }: SectionProps) => {
  const { isSmall } = useDimensions();

  return (
    <div>
      <Box
        sx={{
          width: "100%",
          textAlign: "center",
          py: 2,
        }}
      >
        <Typography
          sx={{
            fontWeight: "600",
            fontSize: isSmall ? 16 : 20,
            textAlign: "left",
          }}
        >
          {title}
        </Typography>
      </Box>

      {children}
    </div>
  );
};

export default Section;
